import { Card, CardContent } from "@/components/ui/card";
import { ExternalLink } from "lucide-react";

interface LocationMapProps {
  lat: number;
  lng: number;
}

const LocationMap = ({ lat, lng }: LocationMapProps) => {
  const googleMapsUrl = `https://maps.google.com/?q=${lat},${lng}`;

  // For a real implementation, you would use a mapping library like Leaflet or Google Maps
  // For this prototype, we'll use a static map image
  const mapImageUrl = `https://storage.googleapis.com/fenado-ai-farm-public/generated/037a6093-6186-4ec5-bd77-6765d085cfc9.png`;

  return (
    <Card className="border-l-2 border-t-2 border-primary/30 mt-4">
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium">Location</h3>
          <a
            href={googleMapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:text-primary/80 text-sm flex items-center"
          >
            Open in Google Maps
            <ExternalLink className="ml-1 h-3 w-3" />
          </a>
        </div>

        <div className="relative rounded-md overflow-hidden">
          <img
            src={mapImageUrl}
            alt="Issue location map"
            className="w-full h-auto object-cover aspect-video"
          />

          {/* Simulated pin */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <div className="w-5 h-5 bg-primary rounded-full border-2 border-white shadow-md animate-pulse"></div>
          </div>

          {/* Coordinates overlay */}
          <div className="absolute bottom-2 left-2 bg-background/80 backdrop-blur-sm px-2 py-1 rounded text-xs font-mono">
            {lat}, {lng}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default LocationMap;
